import { ScrollArea } from '~/primitives/scroll-area';
import { cn } from '~/util';
import { Button } from '~/primitives/button';
import { useLocaleDateTimeString } from '~/util/hooks/useLocale';
import { useApiMutation } from '~/util/hooks/useApiMutation';
import { clearNotificationsMutation } from '~/util/mutations/public/users';
import { useLoaderData } from '@tanstack/react-router';

export default function Notifications() {
    const notifications = useLoaderData({
        from: '__root__',
        select: ({ notifications }) => notifications,
    });
    const clearNotifications = useApiMutation(clearNotificationsMutation());
    const localeDateTimeString = useLocaleDateTimeString();

    return (
        <div className="flex flex-col">
            <ScrollArea>
                <div className="p-1 min-h-[25vh] max-h-[calc(100vh-600px)] w-[25vw] flex flex-col">
                    <div className="flex flex-1 flex-col gap-2 text-center w-full h-full">
                        {notifications.length ? (
                            <>
                                {notifications.map((notification) => (
                                    <div
                                        key={notification.id}
                                        className={cn(
                                            ' py-2 px-4 items-center rounded-sm border-opacity-50 border',
                                            notification.notification_type ===
                                                'Success'
                                                ? 'bg-confirm-transparent border-confirm'
                                                : notification.notification_type ===
                                                    'Failure'
                                                  ? 'bg-destructive-transparent border-destructive'
                                                  : 'bg-pending-transparent border-pending',
                                        )}
                                    >
                                        <p className="text-xs text-left text-neutral-400">
                                            {localeDateTimeString(
                                                notification.created_at,
                                            )}
                                        </p>
                                        <p className="text-left text-sm ">
                                            {notification.content}
                                        </p>
                                    </div>
                                ))}
                                <Button
                                    onClick={() => clearNotifications.mutate()}
                                    className="my-1 mx-4"
                                >
                                    Clear all
                                </Button>
                            </>
                        ) : (
                            <div className="flex flex-1 items-center justify-center">
                                <p className="text-secondary-foreground text-center">
                                    You do not have any notifications.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </ScrollArea>
        </div>
    );
}
